import type { SalarySystemDeliveryType } from '../enums/SalarySystemDeliveryType'
import type { SalarySystemType } from '../enums/SalarySystemType'
import type { SalarySystemSegmentEntity } from './SalarySystemSegmentEntity'

export class SystemSalaryEntity {
  createdAt?: string
  updatedAt?: string
  deletedAt?: string | null
  id?: number
  name?: string | null
  type?: SalarySystemType
  deliveryTypes?: Array<SalarySystemDeliveryType> | null
  perDirectDistance?: {
    amountPerKm?: number
  }
  perRouteDistance?: {
    amountPerKm?: number
  }
  perDirectDistanceSegment?: {
    segments?: Array<SalarySystemSegmentEntity> | null
  }
  perRouteDistanceSegment?: {
    segments?: Array<SalarySystemSegmentEntity> | null
  }
}
